<template>

    <timeregistration-totals
        :project-uuid="project.uuid"
        :show-finances="canViewFinances"
    ></timeregistration-totals>

</template>

<script>

import { mapGetters } from 'vuex';
import Lang from '../../../Lang';
import TimeregistrationTotals from "../../../components/Projects/TimeregistrationTotals";

export default {

    components: {
        TimeregistrationTotals,
    },

    computed: {
        ...mapGetters([
            'getProject',
            'hasLicense',
        ]),

        canViewFinances() {
            return this.hasLicense('finance');
        },

        project() {
            return this.getProject;
        },
    },

    data() {
        return {
            Lang:Lang,
        }
    },

    metaInfo: {
        title:Lang.get('projects.project') + ' - ' + Lang.get('projects.tabs.hourstotals'),
    },

    name:'ProjectsDetailsHourTotals',

}

</script>
